"use client";

import Logo from "@/components/Logo";
import Menu from "@/components/Menu";
import Social from "@/components/Social";
import SelectLocale from "@/components/SelectLocale";
import ThemeToggle from "@/components/ThemeToggle";
import MobileMenu from "@/components/MobileMenu";

function Header() {
  return (
    <header className="sticky top-0 z-40 w-full border-bottom-default bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex items-center py-3 container border-side-default">
        <div className="mt-0 md:mt-[-1px]">
          <Logo />
        </div>
        <div className="hidden md:flex ml-5">
          <Menu />
        </div>
        <div className="hidden md:flex ml-auto items-center gap-4">
          <ThemeToggle />
          <SelectLocale />
          <Social />
        </div>
        <div className="ml-auto flex md:hidden items-center gap-4 min-w-[32px]">
          <ThemeToggle />
          <SelectLocale />
          <MobileMenu />
        </div>
      </div>
    </header>
  );
}

export default Header;